interface PerformanceRecord {
  callCount: number;
  totalTime: number;
  averageTime: number;
  maxTime: number;
  minTime: number;
}

const performanceData = new Map<string, PerformanceRecord>();

export function measure<T extends (...args: any[]) => any>(fn: T, name?: string): T {
  const perfName = name || fn.name;
  if (!perfName) {
    // console.warn('Cannot measure anonymous function without a name. Please provide a name.');
    return fn;
  }

  return async function(this: any, ...args: any[]) {
    const start = performance.now();
    try {
      const result = await fn.apply(this, args);
      return result;
    } finally {
      const end = performance.now();
      const duration = end - start;

      const record = performanceData.get(perfName) || {
        callCount: 0,
        totalTime: 0,
        averageTime: 0,
        maxTime: -Infinity,
        minTime: Infinity,
      };

      record.callCount++;
      record.totalTime += duration;
      record.averageTime = record.totalTime / record.callCount;
      record.maxTime = Math.max(record.maxTime, duration);
      record.minTime = Math.min(record.minTime, duration);

      performanceData.set(perfName, record);
    }
  } as T;
}

function analyze() {
  const data = Array.from(performanceData.entries()).map(([name, record]) => ({
    'Function Name': name,
    'Call Count': record.callCount,
    'Total Time (ms)': record.totalTime.toFixed(2),
    'Average Time (ms)': record.averageTime.toFixed(2),
    'Max Time (ms)': record.maxTime.toFixed(2),
    'Min Time (ms)': record.minTime.toFixed(2),
  }));

  if (data.length === 0) {
    console.log('No performance data collected yet.');
    return;
  }

  data.sort((a, b) => parseFloat(b['Total Time (ms)']) - parseFloat(a['Total Time (ms)']));

  console.table(data);
}

if (typeof window !== 'undefined') {
  (window as any).analyze = analyze;
}